import { Injectable } from '@angular/core';
import { select, Store, Action } from '@ngrx/store';
import {
  CustomerNotificationActionType,
  CustomerNotificationType,
  INotification
} from '@care-portals/api-interfaces';

import * as fromNotification from './notification.reducer';
import * as NotificationActions from './notification.actions';
import * as NotificationSelectors from './notification.selectors';

@Injectable()
export class NotificationFacade {
  loading$ = this.store.pipe(
    select(NotificationSelectors.getNotificationLoading)
  );
  allNotification$ = this.store.pipe(
    select(NotificationSelectors.getAllNotification)
  );
  selectedNotification$ = this.store.pipe(
    select(NotificationSelectors.getSelected)
  );

  constructor(
    private store: Store<fromNotification.NotificationPartialState>
  ) {}

  dispatch(action: Action) {
    this.store.dispatch(action);
  }

  loadNotifications(type: CustomerNotificationType, query: any) {
    this.dispatch(
      NotificationActions.loadNotifications({ notificationType: type, query })
    );
  }

  addNotification(notification: INotification) {
    this.dispatch(NotificationActions.addNotification({ notification }));
  }

  deleteNotification(id: string) {
    this.dispatch(NotificationActions.deleteNotification({ id }));
  }

  clearAllNotification() {
    this.dispatch(NotificationActions.clearAllNotification());
  }

  onAction(actionType: CustomerNotificationActionType, payload: any) {
    this.dispatch(NotificationActions.onAction({ actionType, payload }));
  }
}
